import { useMemo } from 'react';

import { PostInfo } from './types';

export function useData(
  postId: string,
  mdxctx: any
): null | {
  MarkdownComponent: any;
  info: PostInfo;
} {
  const MDKey = useMemo(
    () => mdxctx.keys().find((p: string) => p === './' + postId + '/index.mdx'),
    [mdxctx, postId]
  );

  const mdinfo = useMemo(
    () => mdxctx.keys().find((p: string) => p === './' + postId + '/index.js'),
    [mdxctx, postId]
  );

  const MD = MDKey ? mdxctx(MDKey).default : null;
  const Info = mdinfo ? mdxctx(mdinfo) : null;

  if (!MD || !Info) {
    return null;
  }
  return { MarkdownComponent: MD, info: Info };
}
